import { motion } from "framer-motion";

function DayCard({ day, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.12, ease: "easeOut" }}
      viewport={{ once: true, margin: "-50px" }}
      className="relative flex gap-5"
    >
      <div className="flex flex-col items-center">
        <div
          className="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0 shadow-md"
          style={{ backgroundColor: "#E8470A", boxShadow: "0 0 0 4px rgba(232,71,10,0.15)" }}
        >
          <span className="text-white font-extrabold text-xs">{day.day}</span>
        </div>
        <div className="w-px flex-1 mt-2" style={{ background: "linear-gradient(to bottom, rgba(232,71,10,0.35), transparent)" }} />
      </div>

      <div className="flex-1 pb-10">
        <div
          className="rounded-2xl overflow-hidden"
          style={{ backgroundColor: "#ffffff", border: "1px solid #f0ece4", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
        >
          {day.image && (
            <div className="relative h-44 overflow-hidden">
              <img src={day.image} alt={day.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.5), transparent)" }} />
              <div className="absolute bottom-3 left-4">
                <span
                  className="text-xs font-bold uppercase tracking-widest px-2.5 py-0.5 rounded-full"
                  style={{ color: "#E8470A", backgroundColor: "rgba(255,255,255,0.95)" }}
                >
                  Día {day.day}
                </span>
              </div>
            </div>
          )}

          <div className="p-5">
            <h3 className="font-bold text-base mb-2 leading-snug" style={{ color: "#111827" }}>
              {day.title}
            </h3>
            <p className="text-sm leading-relaxed mb-4" style={{ color: "#6B7280" }}>
              {day.description}
            </p>
            <ul className="flex flex-col gap-2">
              {day.activities.map((act, i) => (
                <li key={i} className="flex items-start gap-2 text-sm" style={{ color: "#6B7280" }}>
                  <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: "#E8470A" }} />
                  {act}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export function ItinerarySection({ destination, days, label, sectionId }) {
  return (
    <section id={sectionId} className="py-24" style={{ backgroundColor: "#f7f4ee" }}>
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true, margin: "-80px" }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12"
        >
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.28em] mb-2" style={{ color: "#E8470A" }}>
              Itinerario
            </p>
            <h2 className="text-3xl md:text-4xl font-extrabold text-balance leading-tight" style={{ color: "#111827" }}>
              Qué hacer en {label} en {destination}
            </h2>
          </div>
          <a
            href="#alojamientos"
            className="font-semibold text-sm hover:underline flex-shrink-0"
            style={{ color: "#E8470A" }}
          >
            Ver alojamientos disponibles →
          </a>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-0 max-w-5xl">
          {days.map((day, i) => (
            <DayCard key={day.day} day={day} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
